module.exports = __webpack_public_path__ + "static/media/man@2x.783a8b5a.jpg";